module.exports = __webpack_public_path__ + "img/android-download-lc.4a24f957.png";